// Roadmap milestone description and start date by milestone id, so reopening a milestone does not
// refetch. Cleared whenever the roadmap data reloads, so a refetched tree also brings fresh details.
export const milestoneDetailsCache = new Map();

export const clearMilestoneDetailsCache = () => milestoneDetailsCache.clear();
